/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { AutocompleteChangeReason, Button, Chip } from "@mui/material";
import { InstructorModel } from "../../Utils/Models";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import InstructorsForm from "./InstructorsForm";
import withRole from "../../Hooks/withRole";
import { hexToColorName } from "../../Utils/Utils";

export const CRUDContext = createContext(new InstructorModel());

function InstructorsTable(props: any) {
  const [contextValue, setContextValue] = useState(new InstructorModel());
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();

  /**
   *
   */
  const instructorColumns = [
    {
      label: `${Vocabulary.firstName}`,
      name: "firstName",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.lastName}`,
      name: "lastName",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.username}`,
      name: "username",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.email}`,
      name: "email",
      options: {
        sort: false,
      },
    },
  ];

  const instructorExpandableColumns = [
    {
      label: `${Vocabulary.brand}`,
      name: "brand",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.model}`,
      name: "model",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.vehicleNumber}`,
      name: "vehicleNumber",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.color}`,
      name: "color",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (rowData: string) => {
          return (
            <>
              <Chip
                key={rowData?.toString()}
                label={""}
                style={{
                  margin: 5,
                  background: rowData,
                }}
              />
            </>
          );
        },
        exportValue: (rowData: string) => hexToColorName(rowData),
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.instructors}
          columns={instructorColumns}
          CRUDEndPoint={endpoints.instructor.user}
          id={TablesIds.instructor}
          handleModalForm={setOpen}
          hideAddButton={true}
          expandableRows={true}
          expandableRowsHeader={true}
          expandableRowObjectLocationName={"instructorDetails.0.vehicleDetails"}
          expandableColumns={instructorExpandableColumns}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue(new InstructorModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue(new InstructorModel());
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.instructorForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <InstructorsForm
                setContextValue={(
                  e: any,
                  client: InstructorModel | null,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => ({})}
                onClose={() => {
                  setOpen(false);
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                  setContextValue(new InstructorModel());
                }}
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
          hideDeleteButton={!props?.delete}
          showPrintButton
          showDownloadButton
          exportWithTimestamp
        />
      </CRUDContext.Provider>
    </div>
  );
}

export default withRole(InstructorsTable);
